<template>
  <div>
    <v-layout wrap align-center class="pt-4">
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Modalidade</label>
          <p>{{ getModalidadeLicitacao(licitacao.modalidade)}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Amparo Legal</label>
          <p v-if="licitacao.amparoLegal">{{licitacao.amparoLegal.lei}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Tipo</label>
          <p v-if="licitacao.tipoLicitacao">{{ getTipoLicitacao(licitacao.tipoLicitacao)}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label>Número do Processo</label>
          <p v-if="licitacao.numProcesso">{{licitacao.numProcesso}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>

      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text">
          <label v-if="licitacao.ehPerfilComprasBR">Órgão</label>
          <label v-else>Responsável</label>
          <p v-if="licitacao.nomeOrgao">{{licitacao.nomeOrgao}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-tipo-disputa">
          <label>Disputa por</label>
          <p v-if="licitacao.tipoDisputa">{{tipoDisputaDesc(licitacao.tipoDisputa)}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-tipo-disputa">
          <label>Modo de disputa</label>
          <p v-if="licitacao.modoDisputa">{{getModoDisputa(licitacao.modoDisputa)}}</p>
          <p v-else>--</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-tipo-disputa">
          <label>Inversão de fases</label>
          <p>{{licitacao.inversaoFases ? 'Sim': 'Não'}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-inicio-envio">
          <label>Data/Hora Início Envio de Propostas</label>
          <p>{{licitacao.dataIniEnvioProposta | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-fim-envio">
          <label>Data/Hora Fim Envio de Propostas</label>
          <p>{{licitacao.dataFimEnvioProposta | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-abertura">
          <label>Data/Hora Abertura Licitação
            <v-tooltip top>
              <v-icon slot="activator" size="15">info</v-icon>
              Abertura de Proposta/Início da Disputa
            </v-tooltip>
          </label>
          <p>{{licitacao.dataAbertura | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-limite-esclarecimento-impugnacao">
          <label>Data/Hora Limite Esclarecimento/Impugnação</label>
          <p>{{licitacao.dataLimiteEsclarecimentoImpugnacao | az-date('DD/MM/YYYY HH:mm:ss')}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-inicio-envio">
          <label>Data/Hora Início Envio de Propostas (Horário de Brasília)</label>
          <p>{{formatarDataBSB(licitacao.dataIniEnvioProposta)}}</p>
        </div>
      </v-flex>
      <v-flex xs12 md3 sm3 d-flex>
        <div class="az-text licitacao-fim-envio">
          <label>Data/Hora Fim Envio de Propostas (Horário de Brasília)</label>
          <p>{{formatarDataBSB(licitacao.dataFimEnvioProposta)}}</p>
        </div>
      </v-flex>
      <v-flex xs12 sm12 d-flex>
        <div class="az-text">
          <label>Objeto</label>
          <p>{{licitacao.objeto}}</p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {modalidadesLicitacao, modosDisputa, tiposDisputa, tiposLicitacao} from '@/core/constants'
import momentTz from 'moment-timezone'

export default {
    name: 'LicitacaoVisualizacaoDadosGerais',
    data(){
        return{
            modalidadesLicitacao,
            tiposDisputa,
            modosDisputa,
            tiposLicitacao
        }
    },
    computed:{
        ...mapState(['licitacao'])
    },
    methods:{
        getModalidadeLicitacao(modalidade){
            return this.modalidadesLicitacao[modalidade]
        },
        tipoDisputaDesc(tipoDisputa) {
            return this.tiposDisputa[tipoDisputa]
        },

        getTipoLicitacao(tipo) {
            return this.tiposLicitacao[tipo] || tipo
        },
        getModoDisputa(modo) {
            return this.modosDisputa[modo]
        },
        formatarDataBSB(value) {
            if (!value) return ''

            const tzDestino = 'America/Sao_Paulo'
            const format    = 'DD/MM/YYYY HH:mm:ss'

            const dataOrigem = momentTz.parseZone(value)

            return dataOrigem.tz(tzDestino).format(format)
        }
    },
    filters:{
        opcaoSimNaoFilter(valor){
            return {S: 'Sim', N: 'Não'}[valor]
        }
    }
}
</script>
<style lang="stylus" scoped>
label
  font-size 14px
  font-weight bold
</style>